export default "__VITE_ASSET__592f8b37__"